import { jwtDecode } from 'jwt-decode';
import { LocalStorageKeys } from '../../constants/localStorageKeys';
import { tokenRefreshInterval } from '../../store/features/authSlice';
import { addNotification, NotificationType } from '../../store/features/notificationsSlice';
import { AppDispatch } from '../../store/store';
// import { store } from '../../store/store';
import api from '../apiInstance';
import { LoginEmailRequest } from './interfaces/LoginEmailRequest'
import { LoginTokensResponse } from './interfaces/LoginTokensResponse'
import { RefreshTokenRequest } from './interfaces/RefreshTokenRequest';
import { AccessToken } from '../../store/interfaces/accessToken';
import { SmartIDLoginResponse, SmartIDVerificationResponse } from './interfaces/SmartIDLoginResponse';
import { SmartIdLoginRequest } from './interfaces/SmartIDLoginRequest';
import { AxiosResponse } from 'axios';
import { AddEmailRequest, AddEmailResponse, AddVerifyEmailData, CreateAccountData, CreateUserResponse, EmailVerificationResponse, ResetPasswordVerifyRequestDto, SmartIdAttachResponse, VerifyEmailData } from './interfaces/Auth';

export const loginUserEmail = async (data: LoginEmailRequest, dispatch: AppDispatch): Promise<LoginTokensResponse> => {
    const res = await api.post<any>(process.env.REACT_APP_RENTIC_AUTH_API_URL! + "/login", data);
    let token;

    if (res.headers["authorization"]) {
        token = res.headers["authorization"].split(" ")[1]
        dispatch(addNotification({message: "Edukalt sisse logitud", type: NotificationType.SUCCESS}))
        localStorage.setItem(LocalStorageKeys.ACCESS_TOKEN, token);
        const decodedToken = jwtDecode<AccessToken>(token);
        localStorage.setItem(LocalStorageKeys.USER_ROLE, decodedToken.role);
        localStorage.setItem(LocalStorageKeys.USER_ID, decodedToken.sub);
        dispatch(tokenRefreshInterval());
    } else {
        // token not attached
    }

    return {
        accessToken: token
    }
}

export const refreshTokens = async (data: RefreshTokenRequest, dispatch: AppDispatch): Promise<LoginTokensResponse> => {
    console.log("refresh tokens request");
    const res = await api.post<any>(process.env.REACT_APP_RENTIC_AUTH_API_URL! + "/update_tokens", {}, {headers: {Authorization: "Bearer " + data.accessToken}});
    let token;

    if (res.headers["authorization"]) {
        token = res.headers["authorization"].split(" ")[1];
        localStorage.setItem(LocalStorageKeys.ACCESS_TOKEN, token);
        const decodedToken = jwtDecode<AccessToken>(token);
        localStorage.setItem(LocalStorageKeys.USER_ROLE, decodedToken.role);
        localStorage.setItem(LocalStorageKeys.USER_ID, decodedToken.sub);
    } else {
        dispatch(addNotification({message: "Token refresh failed", type: NotificationType.ERROR}))
    }

    return {
        accessToken: token
    }
}

export const logout = async (): Promise<string> => {
    const res = await api.post<string>(process.env.REACT_APP_RENTIC_AUTH_API_URL! + "/logout", {});
    return res.data;
}

export const createSmartIdLogin = async (data: SmartIdLoginRequest): Promise<SmartIDLoginResponse> => {
    try {
        const res = await api.post<SmartIDLoginResponse>(process.env.REACT_APP_RENTIC_AUTH_API_URL! + "/create/smart_id_login", data);
        return res.data;
    } catch (e) {
        console.log("ERROR ", e);
        throw e;
    }
}

export const smartIdVerificationRequest = async (isAuthentication: boolean): Promise<AxiosResponse<SmartIDVerificationResponse>> => {
    let verificationUrl = "/verify/smart_id";
    if (!isAuthentication) {
        verificationUrl = "/identify/smart_id";
    }

    const res = await api.post<SmartIDVerificationResponse>(process.env.REACT_APP_RENTIC_AUTH_API_URL! + verificationUrl, {});
    return res;
}

export const attachSmartIdRequest = async (personalCode: string): Promise<SmartIdAttachResponse> => {
    const res = await api.post<SmartIdAttachResponse>(process.env.REACT_APP_RENTIC_AUTH_API_URL! + "/attach_smart_id", {personalCode: personalCode});
    return res.data;
}

export const createAccount = async (createUserData: CreateAccountData): Promise<CreateUserResponse> => {
    const res = await api.post<CreateUserResponse>(process.env.REACT_APP_RENTIC_AUTH_API_URL! + "/signup", createUserData);
    return res.data;
}

export const addEmail = async (addEmailData: AddEmailRequest): Promise<AddEmailResponse> => {
    const res = await api.post<AddEmailResponse>(process.env.REACT_APP_RENTIC_AUTH_API_URL! + "/add_email", addEmailData);
    return res.data;
}

export const verifyEmail = async (verifyEmailData: VerifyEmailData, verificationToken: string): Promise<EmailVerificationResponse> => {
    const res = await api.post<EmailVerificationResponse>(process.env.REACT_APP_RENTIC_AUTH_API_URL! + "/email_verify", verifyEmailData, {headers: {Authorization: 'Bearer ' + verificationToken}});
    return res.data;
}

export const addVerifyEmail = async (verifyEmailData: AddVerifyEmailData): Promise<EmailVerificationResponse> => {
    const res = await api.post<EmailVerificationResponse>(process.env.REACT_APP_RENTIC_AUTH_API_URL! + "/email_add_verify", verifyEmailData);
    return res.data;
}

export const resetPasswordWithEmail = async (email: string): Promise<boolean> => {
    const res = await api.post<boolean>(process.env.REACT_APP_RENTIC_AUTH_API_URL! + "/reset_password", {email: email});
    return res.data;
}

export const passwordResetConfirm = async (data: ResetPasswordVerifyRequestDto, resetToken: string): Promise<boolean> => {
    const res = await api.post<boolean>(process.env.REACT_APP_RENTIC_AUTH_API_URL! + "/verify/reset_password", data, {headers: {"Authorization": "Bearer " + resetToken}});
    return res.data;
}
